import fetch from 'auth/FetchInterceptor'

const AssociationAccountService = {}

AssociationAccountService.getAccountByAssociation = function (status, page, id) {
    return fetch({
        url: `/enter/get-accounts-by-association/${id}?page=${page}&status=${status}`,
        method: 'get',
    });
}

AssociationAccountService.getAccountByAssociationForClose = function (page, id, referenceNumber, associationId) {
    return fetch({
        url: `/enter/close-association-account/${id}?referenceNumber=${referenceNumber}&association=${associationId}`,
        method: 'get',
    });
}

AssociationAccountService.getOne = function (id) {
    return fetch({
        url: `/enter/accountAssociation/` + id,
        method: 'get',
    });
}

AssociationAccountService.getByAssociationBankStatementItem = function (id) {
    return fetch({
        url: `/enter/account-on-bank-statement-item/` + id,
        method: 'get',
    });
}

AssociationAccountService.createManually = function (data) {
    return fetch({
        url: `/enter/accountAssociation/manually`,
        method: 'post',
        data: data
    });
}

AssociationAccountService.closeManually = function (bankStatementItemId, associationAccountId) {
    return fetch({
        url: `/enter/association-bank-statement-close-manually/${bankStatementItemId}/${associationAccountId}`,
        method: 'post',
        data: {}
    });
}

AssociationAccountService.updateManually = function (data, id) {
    return fetch({
        url: `/enter/accountAssociation/manually/${id}`,
        method: 'put',
        data: data
    });
}

AssociationAccountService.setCanceled = function (data, associationId) {
    return fetch({
        url: `/enter/accountAssociation/set-canceled/` + associationId,
        method: 'put',
        data: data
    });
}

AssociationAccountService.sendBillAgain = function (id) {
    return fetch({
        url: `/enter/accountAssociation/send-bill-again/${id}`,
        method: 'post',
        data: {}
    });
}

export default AssociationAccountService;